import './ContentContainer.scss';

import React from 'react';

interface Props {
  children: any;
  fluid?: boolean;
}

export default (props: Props) => (
  <div className={`ContentContainer ${props.fluid ? 'fluid' : ''}`}>{props.children}</div>
);
